import {removeAuth0Storage} from 'js/auth0_storage';

const logoutUser = () => {
    removeAuth0Storage();
    window.location.assign('/logout');
};

export default logoutUser;



// WEBPACK FOOTER //
// ./graphql/logout.js